module.exports = "<div class=\"kuiButtonGroup\">\n  <button class=\"kuiButton kuiButton--basic\">\n    Option A\n  </button>\n  <button class=\"kuiButton kuiButton--basic\">\n    Option B\n  </button>\n  <button class=\"kuiButton kuiButton--basic\">\n    Option C\n  </button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/guide/views/button/button_group.html
 ** module id = 725
 ** module chunks = 0
 **/